/* tslint:disable */
/* eslint-disable */
/**
 * Kinde Management API
 * Provides endpoints to manage your Kinde Businesses
 *
 * The version of the OpenAPI document: 1
 * Contact: support@kinde.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
import { CreateUserRequestIdentitiesInnerFromJSON, CreateUserRequestIdentitiesInnerToJSON, } from './CreateUserRequestIdentitiesInner.js';
import { CreateUserRequestProfileFromJSON, CreateUserRequestProfileToJSON, } from './CreateUserRequestProfile.js';
/**
 * Check if a given object implements the CreateUserRequest interface.
 */
export function instanceOfCreateUserRequest(value) {
    var isInstance = true;
    return isInstance;
}
export function CreateUserRequestFromJSON(json) {
    return CreateUserRequestFromJSONTyped(json, false);
}
export function CreateUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'profile': !exists(json, 'profile') ? undefined : CreateUserRequestProfileFromJSON(json['profile']),
        'organizationCode': !exists(json, 'organization_code') ? undefined : json['organization_code'],
        'identities': !exists(json, 'identities') ? undefined : (json['identities'].map(CreateUserRequestIdentitiesInnerFromJSON)),
    };
}
export function CreateUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'profile': CreateUserRequestProfileToJSON(value.profile),
        'organization_code': value.organizationCode,
        'identities': value.identities === undefined ? undefined : (value.identities.map(CreateUserRequestIdentitiesInnerToJSON)),
    };
}
